import { People as PeopleIcon } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { vehiclesRoute } from "../../../navbar/routes";
import { Vehicle } from "../../../../redux/api/VehiclesApi";
import { VehiclesContext } from "../../VehiclesComponent";

interface ViewVehicleGroupMembersButtonProps {
  groupId: string;
}

export const ViewVehicleGroupMembersButton: FC<
  ViewVehicleGroupMembersButtonProps
> = ({ groupId }) => {
  const { t } = useTranslation();
  const label = t("vehicles.groups.viewMembers");
  const router = useNavigate();
  const [queryOptions, setQueryOptions] = useOutletContext<VehiclesContext>();

  const onClick = () => {
    router(`${vehiclesRoute.path}`);
    setQueryOptions({
      ...queryOptions,
      filterField: "groupId" as keyof Vehicle,
      filterOperator: "is",
      filterValue: groupId,
    });
  };

  return (
    <GridActionsCellItem
      icon={
        <Tooltip title={label}>
          <PeopleIcon />
        </Tooltip>
      }
      label={label}
      onClick={onClick}
    />
  );
};
